import React, { useState } from 'react'
import "./navbar.css"
import logo from "../../assets/logo.svg"
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';


const Menu = () =>{
  return(
  <>
    <p><a href="#Home">Home</a></p>
    <p><a href="#wgpt3">What is GPT?</a></p>
    <p><a href="#possibility">OpenAI</a></p>
    <p><a href="#features">Case Studies</a></p>
    <p><a href="#blog">Library</a></p>
  </>
  )
}


const Navbar = () => {

  const [toggleMenu , setToggleMenu] = useState(false)

  return (
    <div className='gpt3__navbar'>
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links-logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="gpt3__navbar-links-container">
          
          <Menu />

        </div>
      </div>

      <div className="gpt3__navbar-sign">
        <p onClick={()=>{
          window.open("https://chat.openai.com/auth/login")
        }}>Sign In</p>
        <button 
        onClick={()=>{
          window.open("https://chat.openai.com/auth/login")
        }}>Sign Up</button>
      </div>

      <div className="gpt3__navbar-menu">
        {toggleMenu 
        ? <RiCloseLine color="#fff" size={27} onClick={()=>setToggleMenu(false)} />
         : <RiMenu3Line color="#fff" size={27} onClick={()=>setToggleMenu(true)} /> 
        }

        {toggleMenu && 
          <div className="gpt3__navbar-menu-container scale-up-center">
            <div className="gpt3__navbar-menu-container-links">
              
              <Menu />

            </div>

            <div className="gpt3__navbar-menu-container-links-sign">
              <p onClick={()=>{
                window.open("https://chat.openai.com/auth/login")
                }}>Sign In</p>
              <button onClick={()=>{
                window.open("https://chat.openai.com/auth/login")
                }}>Sign Up</button>
            </div>

          </div>
        } 
      </div>



      
    </div>
  )
}

export default Navbar